import React from "react";
import "./index.scss";
import MdaeTextBox from "../common_widgets/text-box";
import MdaeButton from "../common_widgets/button";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterStartButtons,
  MdaePopupFooterEndButtons,
} from "../common_widgets/popup";
import {
  initialSearchProviderPopupData,
  SET_ADD_CASE_MANUAL_DATA,
  SET_SEARCH_PROVIDER_POPUP_DATA,
  SET_SEARCH_PROVIDER_POPUP_DATA_MANUALLY,
  TOGGLE_SEARCH_PROVIDER_POPUP,
} from "./reducer/add-case-manual-reducer";
import "bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
import { callOperation } from "async-ops";
import { GET_CMS_PROVIDER_BY_NPI } from "./services/get-cms-provider-by-npi";
import { ADD_CLIENT_PROVIDER_BY_NPI } from "./services/add-client-provider-by-npi";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../common_components/mdae-common-reducer";

interface ISearchProvider {}
export const toggleSearchProviderPopup = (
  dispatch,
  isVisible,
  launcher = null
) => {
  dispatch({
    type: TOGGLE_SEARCH_PROVIDER_POPUP,
    data: {
      isSearchProviderPopupVisible: isVisible,
    },
  });
  if (isVisible) {
    dispatch({
      type: TOGGLE_SEARCH_PROVIDER_POPUP,
      data: {
        searchProviderPopupData: {
          ...initialSearchProviderPopupData,
          launcher,
        },
      },
    });
  }
};
const SearchProvider: React.FC<ISearchProvider> = () => {
  const dispatch = useDispatch();
  const searchProviderPopupData = useSelector(
    (state) => state["addCaseManualReducer"].searchProviderPopupData,
    isEqual
  );
  const setProviderSearchResult = (data) => {
    dispatch({ type: SET_SEARCH_PROVIDER_POPUP_DATA_MANUALLY, data });
  };
  const getSearchProviderPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          toggleSearchProviderPopup(dispatch, false);
        }}
      >
        Search Provider
      </MdaePopupTitle>
    );
  };
  return (
    <MdaePopup
      deferRendering={false}
      height={250}
      width={520}
      className="add-case-manual-popup"
      titleRender={getSearchProviderPopupTitle}
      mdaeDataUpdaterConfig={[
        {
          actionType: TOGGLE_SEARCH_PROVIDER_POPUP,
          reducerName: "addCaseManualReducer",
          widgetOptionBindings: {
            visible: "isSearchProviderPopupVisible",
          },
        },
      ]}
      mdaeContentRender={() => (
        <MdaePopupContent>
          <div className="col-xs-12 remove-padding" style={{ display: "flex" }}>
            <MdaeTextBox
              id="txtProviderNPI"
              mdaeTextBoxTitle="Provider NPI"
              width={320}
              style={{ marginRight: 20 }}
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_SEARCH_PROVIDER_POPUP_DATA,
                  reducerName: "addCaseManualReducer",
                  widgetOptionBindings: {
                    value: "searchProviderPopupData.provider.nPI",
                  },
                },
                {
                  actionType: TOGGLE_SEARCH_PROVIDER_POPUP,
                  reducerName: "addCaseManualReducer",
                  widgetOptionBindings: {
                    value: "searchProviderPopupData.provider.nPI",
                  },
                },
              ]}
            />
            <MdaeButton
              stylingMode="text"
              role="dxButton"
              id="btnManualSearchBillingProvider"
              icon="fa fa-search application-section-primary-color"
              onClick={() => {
                if (searchProviderPopupData?.provider.nPI) {
                  dispatch({ type: SHOW_LOADER });
                  callOperation(
                    GET_CMS_PROVIDER_BY_NPI,
                    searchProviderPopupData?.provider
                  ).then((response) => {
                    if (response != null) {
                      const NPI = response;
                      const npiName =
                        "Provider found - " +
                        response.lastName +
                        "," +
                        response.firstName;
                      setProviderSearchResult({
                        NPI,
                        npiName,
                      });
                    } else {
                      setProviderSearchResult({
                        npiName: "Provider not found.",
                      });
                    }
                    dispatch({ type: HIDE_LOADER });
                  });
                } else {
                  setProviderSearchResult({
                    npiName: "Provider not found.",
                  });
                }
              }}
            />
          </div>
          <div className="col-xs-12 remove-padding div-label margin-s-top">
            <div
              id="lbl-provider-directive-npi-name"
              className="mdae-standalone-label application-section-primary-color"
            >
              {searchProviderPopupData?.npiName}
            </div>
          </div>
        </MdaePopupContent>
      )}
      mdaeFooterRender={() => {
        return (
          <MdaePopupFooter>
            <MdaePopupFooterStartButtons>
              <MdaeButton
                id={"btnCancelAddCaseManualPopup"}
                role={"secondary"}
                onClick={() => {
                  toggleSearchProviderPopup(dispatch, false);
                }}
              >
                Cancel
              </MdaeButton>
            </MdaePopupFooterStartButtons>
            <MdaePopupFooterEndButtons>
              <MdaeButton
                id={"btnSaveAddCaseManualPopup"}
                role={"primary"}
                onClick={() => {
                  if (searchProviderPopupData?.provider.nPI) {
                    callOperation(
                      ADD_CLIENT_PROVIDER_BY_NPI,
                      searchProviderPopupData?.provider.nPI
                    ).then((response) => {
                      const clientProviderId = response.clientProviderId;
                      let providerKeyName = "";
                      if (clientProviderId) {
                        switch (
                          searchProviderPopupData.launcher.toLowerCase()
                        ) {
                          case "billingprovider":
                            providerKeyName = "billingProviderId";
                            break;
                          case "renderingprovider":
                            providerKeyName = "renderingProviderId";
                            break;
                          case "attendingprovider":
                            providerKeyName = "attendingProviderId";
                        }
                        dispatch({
                          type: SET_ADD_CASE_MANUAL_DATA,
                          data: {
                            addCaseManualFormData: {
                              [providerKeyName]: clientProviderId,
                            },
                          },
                        });
                      }
                    });
                  }
                  toggleSearchProviderPopup(dispatch, false);
                }}
              >
                OK
              </MdaeButton>
            </MdaePopupFooterEndButtons>
          </MdaePopupFooter>
        );
      }}
    />
  );
};

export default SearchProvider;
